// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Semigroupoid from "../Control.Semigroupoid/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either_Extra from "../Data.Either.Extra/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_String_Regex from "../Data.String.Regex/index.js";
import * as Data_String_Regex_Flags from "../Data.String.Regex.Flags/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Data_Validation_Semigroup.applicativeV(Data_Semigroup.semigroupArray));
var $$null = /* #__PURE__ */ Data_Foldable["null"](Data_Foldable.foldableArray);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Data_Monoid.monoidArray);
var newCallback = /* #__PURE__ */ Specular_Callback.newCallback();
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(Specular_FRP_Base.functorEvent);
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var apply = /* #__PURE__ */ Control_Apply.apply(Specular_FRP_Base.applyDynamic);
var show1 = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Validation_Semigroup.functorV);
var greaterThanOrEq1 = /* #__PURE__ */ Data_Ord.greaterThanOrEq(Data_Money_Rounded.ordMoney);
var zero = /* #__PURE__ */ Data_Numeric.zero(Data_Money_Rounded.additiveMoney);
var greaterThan1 = /* #__PURE__ */ Data_Ord.greaterThan(Data_Money_Rounded.ordMoney);
var lift3 = /* #__PURE__ */ Control_Apply.lift3(Specular_FRP_Base.applyDynamic);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var show2 = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var ordArray = /* #__PURE__ */ Data_Ord.ordArray(Data_Ord.ordString);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(ordArray);
var apply1 = /* #__PURE__ */ Control_Apply.apply(Data_Maybe.applyMaybe);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Data_Maybe.applicativeMaybe);
var fromFoldable = /* #__PURE__ */ Data_Map_Internal.fromFoldable(ordArray)(Data_Foldable.foldableArray);
var toUnfoldable = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var negate = /* #__PURE__ */ Data_Numeric.negate(Data_Numeric.additiveNumber);
var FormField = function (x) {
    return x;
};
var Conversion = function (x) {
    return x;
};
var semigroupoidConversion = {
    compose: function (v) {
        return function (v1) {
            return {
                fromInitial: function ($187) {
                    return v.fromInitial(v1.fromInitial($187));
                },
                toFinal: (function () {
                    var $188 = Data_Validation_Semigroup.validation(Data_Validation_Semigroup.invalid)(v1.toFinal);
                    return function ($189) {
                        return $188(v.toFinal($189));
                    };
                })()
            };
        };
    }
};
var compose1 = /* #__PURE__ */ Control_Semigroupoid.compose(semigroupoidConversion);
var phoneRE = /* #__PURE__ */ Data_Either_Extra.fromRightWith(function (e) {
    return Partial_Unsafe.unsafeCrashWith(show(e));
})(/* #__PURE__ */ Data_String_Regex.regex("^\\+?[0-9 -]+$")(Data_String_Regex_Flags.noFlags));
var normalizeDecimalSeparator = function (s) {
    var $99 = Data_String_CodeUnits.contains(".")(s);
    if ($99) {
        return s;
    };
    return Data_String_Common.replace(",")(".")(s);
};
var nonNothingConversion = function (errorMsg) {
    return {
        fromInitial: identity,
        toFinal: function (x) {
            var $100 = Data_Maybe.isNothing(x);
            if ($100) {
                return Data_Validation_Semigroup.invalid([ errorMsg ]);
            };
            return pure(x);
        }
    };
};
var nonEmptyStringConversion = function (errorMsg) {
    return {
        fromInitial: identity,
        toFinal: function (x) {
            var $101 = Data_String_Common["null"](Data_String_Common.trim(x));
            if ($101) {
                return Data_Validation_Semigroup.invalid([ errorMsg ]);
            };
            return pure(x);
        }
    };
};
var nonEmptyArrayConversion = function (errorMessage) {
    return {
        fromInitial: identity,
        toFinal: function (x) {
            var $102 = $$null(x);
            if ($102) {
                return Data_Validation_Semigroup.invalid([ errorMessage ]);
            };
            return pure(x);
        }
    };
};
var noFieldState = {
    submitOccured: Specular_FRP_Base.never,
    remoteErrors: /* #__PURE__ */ pure1(mempty)
};
var newFormFieldEDyn = function (dictMonadFRP) {
    var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
    var bind = Control_Bind.bind(Monad0.Bind1());
    var MonadEffect0 = dictMonadFRP.MonadEffect0();
    var newRef = Specular_Ref.newRef(MonadEffect0);
    var newCallback1 = newCallback(MonadEffect0);
    var holdDyn = Specular_FRP_Base.holdDyn(dictMonadFRP);
    var pure3 = Control_Applicative.pure(Monad0.Applicative0());
    return function (conversion) {
        return function (remoteState) {
            return function (initial) {
                return bind(newRef(initial))(function (ref) {
                    return bind(newCallback1)(function (focusOutCallback1) {
                        return bind(holdDyn(false)(Specular_FRP_Base.leftmost([ voidRight(true)(focusOutCallback1.event), voidRight(true)(remoteState.submitOccured) ])))(function (isTouched1) {
                            var toFinal = map(function (v) {
                                return v.toFinal;
                            })(conversion);
                            return pure3({
                                editRef: ref,
                                focusOutCallback: focusOutCallback1.callback,
                                finalValue: apply(map(Data_Function.apply)(toFinal))(Specular_Ref.refValue(ref)),
                                isTouched: isTouched1,
                                remoteState: remoteState
                            });
                        });
                    });
                });
            };
        };
    };
};
var newFormFieldE = function (dictMonadFRP) {
    var newFormFieldEDyn1 = newFormFieldEDyn(dictMonadFRP);
    return function (conversion) {
        return function (remoteState) {
            return function (initial) {
                return newFormFieldEDyn1(pure1(conversion))(remoteState)(initial);
            };
        };
    };
};
var newFormField = function (dictMonadFRP) {
    var newFormFieldE1 = newFormFieldE(dictMonadFRP);
    return function (v) {
        return function (remoteState) {
            return function (initial) {
                return newFormFieldE1(v)(remoteState)(v.fromInitial(initial));
            };
        };
    };
};
var moneyRE = /* #__PURE__ */ Data_Either_Extra.fromRightWith(function (e) {
    return Partial_Unsafe.unsafeCrashWith(show(e));
})(/* #__PURE__ */ Data_String_Regex.regex("^-?[0-9]+([,\\.][0-9]{2})?$")(Data_String_Regex_Flags.noFlags));
var maybeStringConversion = /* #__PURE__ */ (function () {
    var toFinal = function (v) {
        if (v === "") {
            return pure(Data_Maybe.Nothing.value);
        };
        return pure(new Data_Maybe.Just(v));
    };
    return {
        fromInitial: Data_Maybe.fromMaybe(""),
        toFinal: toFinal
    };
})();
var maybeConversion = function (errorMessage) {
    return {
        fromInitial: Data_Maybe.Just.create,
        toFinal: function (v) {
            if (v instanceof Data_Maybe.Just) {
                return pure(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Validation_Semigroup.invalid([ errorMessage ]);
            };
            throw new Error("Failed pattern match at Specular.FormField (line 254, column 9 - line 256, column 46): " + [ v.constructor.name ]);
        }
    };
};
var isTouched = function (v) {
    return v.isTouched;
};
var intConversion = function (errorMessage) {
    return {
        fromInitial: show1,
        toFinal: function (e) {
            var v = Data_Int.fromString(e);
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Validation_Semigroup.invalid([ errorMessage ]);
            };
            if (v instanceof Data_Maybe.Just) {
                return pure(v.value0);
            };
            throw new Error("Failed pattern match at Specular.FormField (line 310, column 9 - line 312, column 27): " + [ v.constructor.name ]);
        }
    };
};
var intPositivePercentageConversion = function (v) {
    return compose1(intConversion(v.numError))({
        fromInitial: identity,
        toFinal: function (x) {
            var $116 = x >= 1 && x <= 100;
            if ($116) {
                return pure(x);
            };
            return Data_Validation_Semigroup.invalid([ v.percentageError ]);
        }
    });
};
var nonNegativeIntConversion = function (v) {
    return compose1(intConversion(v.intError))({
        fromInitial: identity,
        toFinal: function (x) {
            var $120 = x >= 0;
            if ($120) {
                return pure(x);
            };
            return Data_Validation_Semigroup.invalid([ v.nonNegativeIntError ]);
        }
    });
};
var positiveIntConversion = function (v) {
    return compose1(intConversion(v.intError))({
        fromInitial: identity,
        toFinal: function (x) {
            var $124 = x > 0;
            if ($124) {
                return pure(x);
            };
            return Data_Validation_Semigroup.invalid([ v.positiveIntError ]);
        }
    });
};
var rangeIntConversion = function (v) {
    return compose1(intConversion(v.intError))({
        fromInitial: identity,
        toFinal: function (x) {
            var $128 = v.max >= x && x >= v.min;
            if ($128) {
                return pure(x);
            };
            return Data_Validation_Semigroup.invalid([ v.rangeIntError ]);
        }
    });
};
var fromValidV = /* #__PURE__ */ (function () {
    return Data_Validation_Semigroup.validation(Data_Function["const"](Data_Maybe.Nothing.value))(Data_Maybe.Just.create);
})();
var focusOutCallback = function (v) {
    return v.focusOutCallback;
};
var finalValueNoErr = function (v) {
    return Restaumatic_Form_Final.makeFinal(map(fromValidV)(v.finalValue));
};
var finalValue = function (v) {
    return v.finalValue;
};
var fieldStateEmpty = function (formState) {
    return {
        submitOccured: formState.submitOccured,
        remoteErrors: pure1(mempty)
    };
};
var errorsFromV = function (dictMonoid) {
    var mempty1 = Data_Monoid.mempty(dictMonoid);
    return Data_Validation_Semigroup.validation(identity)(function (v) {
        return mempty1;
    });
};
var errorsFromV1 = /* #__PURE__ */ errorsFromV(Data_Monoid.monoidArray);
var emptyConversion = function (dictMonoid) {
    var mempty1 = Data_Monoid.mempty(dictMonoid);
    return function (dictEq) {
        var eq = Data_Eq.eq(dictEq);
        return function (v) {
            return {
                fromInitial: Data_Maybe.maybe(mempty1)(v.fromInitial),
                toFinal: function (x) {
                    var $137 = eq(x)(mempty1);
                    if ($137) {
                        return pure(Data_Maybe.Nothing.value);
                    };
                    return map1(Data_Maybe.Just.create)(v.toFinal(x));
                }
            };
        };
    };
};
var emailRE = /* #__PURE__ */ Data_Either_Extra.fromRightWith(function (e) {
    return Partial_Unsafe.unsafeCrashWith(show(e));
})(/* #__PURE__ */ Data_String_Regex.regex("^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)+$")(Data_String_Regex_Flags.noFlags));
var editRef = function (v) {
    return v.editRef;
};
var formFieldValue = function ($190) {
    return Specular_Ref.refValue(editRef($190));
};
var doesPhoneMatchRegex = /* #__PURE__ */ Data_String_Regex.test(phoneRE);
var maybePhoneConversion = function (errorMsg) {
    return {
        fromInitial: Data_Maybe.fromMaybe(""),
        toFinal: function (x) {
            var xt = Data_String_Common.trim(x);
            var $141 = Data_String_Common["null"](xt);
            if ($141) {
                return pure(Data_Maybe.Nothing.value);
            };
            var $142 = doesPhoneMatchRegex(xt);
            if ($142) {
                return pure(new Data_Maybe.Just(xt));
            };
            return Data_Validation_Semigroup.invalid([ errorMsg ]);
        }
    };
};
var phoneConversion = function (errorMsg) {
    return {
        fromInitial: identity,
        toFinal: function (x) {
            var xt = Data_String_Common.trim(x);
            var $143 = doesPhoneMatchRegex(xt);
            if ($143) {
                return pure(xt);
            };
            return Data_Validation_Semigroup.invalid([ errorMsg ]);
        }
    };
};
var doesMoneyMatchRegex = /* #__PURE__ */ Data_String_Regex.test(moneyRE);
var moneyConversion = function (errorMessage) {
    return {
        fromInitial: Data_Money_Rounded.toString,
        toFinal: function (x) {
            var v = Data_Money_Rounded.fromString(normalizeDecimalSeparator(x));
            var v1 = doesMoneyMatchRegex(x);
            if (v1 && v instanceof Data_Maybe.Just) {
                return pure(v.value0);
            };
            return Data_Validation_Semigroup.invalid([ errorMessage ]);
        }
    };
};
var nonNegativeMoneyConversion = function (v) {
    return compose1(moneyConversion(v.moneyError))({
        fromInitial: identity,
        toFinal: function (x) {
            var $148 = greaterThanOrEq1(x)(zero);
            if ($148) {
                return pure(x);
            };
            return Data_Validation_Semigroup.invalid([ v.nonNegativeMoneyError ]);
        }
    });
};
var positiveMoneyConversion = function (v) {
    return compose1(moneyConversion(v.moneyError))({
        fromInitial: identity,
        toFinal: function (x) {
            var $152 = greaterThan1(x)(zero);
            if ($152) {
                return pure(x);
            };
            return Data_Validation_Semigroup.invalid([ v.positiveMoneyError ]);
        }
    });
};
var doesEmailMatchRegex = /* #__PURE__ */ Data_String_Regex.test(emailRE);
var emailConversion = function (errorMsg) {
    return {
        fromInitial: identity,
        toFinal: function (x) {
            var xt = Data_String_Common.trim(x);
            var $155 = doesEmailMatchRegex(xt);
            if ($155) {
                return pure(xt);
            };
            return Data_Validation_Semigroup.invalid([ errorMsg ]);
        }
    };
};
var maybeEmailConversion = function (errorMsg) {
    return {
        fromInitial: Data_Maybe.fromMaybe(""),
        toFinal: function (x) {
            var xt = Data_String_Common.trim(x);
            var $156 = Data_String_Common["null"](xt);
            if ($156) {
                return pure(Data_Maybe.Nothing.value);
            };
            var $157 = doesEmailMatchRegex(xt);
            if ($157) {
                return pure(new Data_Maybe.Just(xt));
            };
            return Data_Validation_Semigroup.invalid([ errorMsg ]);
        }
    };
};
var nonEmptyEmailConversion = function (v) {
    return {
        fromInitial: identity,
        toFinal: function (x) {
            var xt = Data_String_Common.trim(x);
            if (xt === "") {
                return Data_Validation_Semigroup.invalid([ v.emptyErrorMsg ]);
            };
            if (doesEmailMatchRegex(xt)) {
                return pure(xt);
            };
            if (Data_Boolean.otherwise) {
                return Data_Validation_Semigroup.invalid([ v.invalidEmailMsg ]);
            };
            throw new Error("Failed pattern match at Specular.FormField (line 449, column 11 - line 453, column 57): " + [ xt.constructor.name ]);
        }
    };
};
var displayedErrors = function (v) {
    return lift3(function ($$final) {
        return function (remote) {
            return function (isTouched$prime) {
                return append((function () {
                    if (isTouched$prime) {
                        return errorsFromV1($$final);
                    };
                    return [  ];
                })())(remote);
            };
        };
    })(v.finalValue)(v.remoteState.remoteErrors)(v.isTouched);
};
var decimalRE = /* #__PURE__ */ Data_Either_Extra.fromRightWith(function (e) {
    return Partial_Unsafe.unsafeCrashWith(show(e));
})(/* #__PURE__ */ Data_String_Regex.regex("^-?[0-9]+([,\\.][0-9]+)?$")(Data_String_Regex_Flags.noFlags));
var doesNumberMatchRegex = /* #__PURE__ */ Data_String_Regex.test(decimalRE);
var numberConversion = function (errorMessage) {
    return {
        fromInitial: show2,
        toFinal: function (e) {
            var v = Data_Number.fromString(normalizeDecimalSeparator(e));
            var v1 = doesNumberMatchRegex(e);
            if (v1 && v instanceof Data_Maybe.Just) {
                return pure(v.value0);
            };
            return Data_Validation_Semigroup.invalid([ errorMessage ]);
        }
    };
};
var nonNegativeNumberConversion = function (v) {
    return compose1(numberConversion(v.numError))({
        fromInitial: identity,
        toFinal: function (x) {
            var $168 = x >= 0.0;
            if ($168) {
                return pure(x);
            };
            return Data_Validation_Semigroup.invalid([ v.nonNegativeNumError ]);
        }
    });
};
var percentageConversion = function (v) {
    return compose1(numberConversion(v.numError))({
        fromInitial: identity,
        toFinal: function (x) {
            var $172 = x >= 0.0 && x <= 100.0;
            if ($172) {
                return pure(x);
            };
            return Data_Validation_Semigroup.invalid([ v.percentageError ]);
        }
    });
};
var positiveNumberConversion = function (v) {
    return compose1(numberConversion(v.numError))({
        fromInitial: identity,
        toFinal: function (x) {
            var $176 = x > 0.0;
            if ($176) {
                return pure(x);
            };
            return Data_Validation_Semigroup.invalid([ v.positiveNumError ]);
        }
    });
};
var categoryConversion = {
    identity: {
        fromInitial: identity,
        toFinal: pure
    },
    Semigroupoid0: function () {
        return semigroupoidConversion;
    }
};
var atPath = function (path) {
    var $191 = Data_Maybe.fromMaybe(mempty);
    var $192 = lookup(path);
    return function ($193) {
        return $191($192($193));
    };
};
var fieldState = function (path) {
    return function (formState) {
        return {
            submitOccured: formState.submitOccured,
            remoteErrors: map(atPath(path))(formState.remoteErrors)
        };
    };
};
var arrayStripPrefix = function (dictEq) {
    var eq = Data_Eq.eq(Data_Eq.eqArray(dictEq));
    return function (prefix) {
        return function (input) {
            var $179 = eq(Data_Array.take(Data_Array.length(prefix))(input))(prefix);
            if ($179) {
                return new Data_Maybe.Just(Data_Array.drop(Data_Array.length(prefix))(input));
            };
            return Data_Maybe.Nothing.value;
        };
    };
};
var arrayStripPrefix1 = /* #__PURE__ */ arrayStripPrefix(Data_Eq.eqString);
var stripPathPrefix = function (prefix) {
    var strip = function (v) {
        return apply1(map2(Data_Tuple.Tuple.create)(arrayStripPrefix1(prefix)(v.value0)))(pure2(v.value1));
    };
    var $194 = Data_Array.mapMaybe(strip);
    return function ($195) {
        return fromFoldable($194(toUnfoldable($195)));
    };
};
var focusFormState = function (path) {
    return function (formState) {
        return {
            submitOccured: formState.submitOccured,
            remoteErrors: map(stripPathPrefix(path))(formState.remoteErrors)
        };
    };
};
var anyPercentageConversion = function (v) {
    return compose1(numberConversion(v.numError))({
        fromInitial: identity,
        toFinal: function (x) {
            var $184 = x >= negate(100.0) && x <= 100.0;
            if ($184) {
                return pure(x);
            };
            return Data_Validation_Semigroup.invalid([ v.percentageError ]);
        }
    });
};
export {
    Conversion,
    FormField,
    anyPercentageConversion,
    atPath,
    displayedErrors,
    editRef,
    emailConversion,
    emptyConversion,
    fieldState,
    fieldStateEmpty,
    finalValue,
    finalValueNoErr,
    focusFormState,
    focusOutCallback,
    formFieldValue,
    intConversion,
    intPositivePercentageConversion,
    isTouched,
    maybeConversion,
    maybeEmailConversion,
    maybePhoneConversion,
    maybeStringConversion,
    moneyConversion,
    newFormField,
    newFormFieldE,
    newFormFieldEDyn,
    noFieldState,
    nonEmptyArrayConversion,
    nonEmptyEmailConversion,
    nonEmptyStringConversion,
    nonNegativeIntConversion,
    nonNegativeMoneyConversion,
    nonNegativeNumberConversion,
    nonNothingConversion,
    numberConversion,
    percentageConversion,
    phoneConversion,
    positiveIntConversion,
    positiveMoneyConversion,
    positiveNumberConversion,
    rangeIntConversion,
    stripPathPrefix,
    semigroupoidConversion,
    categoryConversion
};
export {
    bindFinal,
    invalidFinal,
    liftDynamic,
    liftMaybe,
    makeFinal,
    unFinal
} from "../Restaumatic.Form.Final/index.js";
